import React, { useEffect, useMemo, useState } from "react";
import { IoTrashOutline } from "react-icons/io5";
import { LuMinus, LuPlus } from "react-icons/lu";
import NumberFormat from "react-number-format";
import { connect } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { Button, Modal } from "semantic-ui-react";
import styled from "styled-components";
import { ClientModel } from "../../entities/client.model";
import store from "../../store";
import { getEffectivePrice } from "../../utils/shared.utils";
import ClientLoginComponent from "../authentication/login";
import ClientSignUpComponent from "../authentication/signup";
import "./basket-sidebar.scss";
import DeliveryProgress from "./delivery-progress";

interface BasketSidebarProps {
  basketItems: any;
  totalAmount: number;
  settings: any;
  client: ClientModel;
}

const FormGroup = styled.div`
  padding: 0 20px;
`;

const mapStateToProps = (state: any) => {
  let basketItems: any[] = [];
  let totalAmount: number = 0;
  let settings;

  const isClubMember = state.client?.company?.clubMember;
  if (state.products && state.basket && state.basket.quantityById) {
    state.products.forEach((product: any) => {
      if (
        state.basket.quantityById[product.id] !== null &&
        state.basket.quantityById[product.id] !== undefined
      ) {
        // exists in the basket
        product["count"] = state.basket.quantityById[product.id];
        basketItems.push(product);
        totalAmount += product.count * getEffectivePrice(product, isClubMember);
      }
    });
  }
  return {
    basketItems: basketItems,
    totalAmount: totalAmount,
    settings: state.settings,
    client: state.client,
  };
};

const isMobile = (): boolean => {
  if (typeof window !== "undefined") {
    return window.innerWidth <= 768;
  }
  return false;
};

function BasketSidebar(props: BasketSidebarProps) {
  let history = useHistory();
  const [open, setOpen] = React.useState(false);
  const [modalAction, setModalAction] = React.useState("");
  const deliveryFee = useMemo(() => {
    return props.settings && props.totalAmount < props.settings.freeDeliveryMinAmount ? props.settings.deliveryPrice : 0;
  }, [props.settings, props.totalAmount]);
  
  const calculatedTotal = props.totalAmount + deliveryFee;

  const [mobile, setMobile] = useState(false);

  useEffect(() => {
    setMobile(isMobile());

    const handleResize = () => setMobile(isMobile());
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (props?.client?.id && modalAction !== "") {
      document.body.classList.remove("no-scroll");
      history.push("/client/checkout");
      store.dispatch({
        type: "basketOpen",
        value: false,
      });
      setOpen(false);
      setModalAction("");
    }
  }, [props.client]);

  const closeSidebar = () => {
    store.dispatch({
      type: "basketOpen",
      value: false,
    });
    document.body.classList.remove("no-scroll");
  };

  const removeItemFromBasket = (product: any) => {
    store.dispatch({
      type: "removeItemFromBasket",
      product: product,
    });
  };

  const onItemCountChange = (index: number, e: any) => {
    if (!e.target.value || e.target.value === "0") {
      store.dispatch({
        type: "updateBasketItemCount",
        product: props.basketItems[index],
        count: "0",
      });
      return;
    }
    let count: number = Number(e.target.value);
    if (count > props.basketItems[index].warehouseCount) {
      return;
    }
    store.dispatch({
      type: "updateBasketItemCount",
      product: props.basketItems[index],
      count: count,
    });
  };

  const onItemCountBlur = (index: number, e: any) => {
    if (!e.target.value || e.target?.value === "0") {
      store.dispatch({
        type: "removeItemFromBasket",
        product: props.basketItems[index],
      });
    }
  };

  const continueAction = () => {
    if (props?.client?.id) {
      document.body.classList.remove("no-scroll");
      history.push("/client/checkout");
      store.dispatch({
        type: "basketOpen",
        value: false,
      });
    } else {
      setOpen(true);
      setModalAction("LOGIN");
    }
  };

  const itemIncreaseCount = (index: number) => {
    let count = props.basketItems[index].count;
    if (count >= props.basketItems[index].warehouseCount) {
      return;
    }
    count += 1;
    store.dispatch({
      type: "updateBasketItemCount",
      product: props.basketItems[index],
      count: count,
    });
  };

  const itemDecreaseCount = (index: number) => {
    let count = props.basketItems[index].count;
    if (count < 1) {
      count = 0;
    } else {
      count -= 1;
    }
    store.dispatch({
      type: "updateBasketItemCount",
      product: props.basketItems[index],
      count: count,
    });
  };

  return (
    <div className="basket-sidebar">
      <div className="black-layer" onClick={() => closeSidebar()}></div>
      <div className="sidebar-background"></div>

      <div className="sidebar-container">
        <div className="sidebar-inner">
          {mobile && (
            <div className="close-section">
              <h3>
                Миний сагс
                <span> ({props.basketItems.length} бүтээгдэхүүн)</span>
              </h3>
              <i className="icon icon-cross" onClick={() => closeSidebar()}></i>
            </div>
          )}
          <h2></h2>
          {!mobile && (
            <div className="close-section">
              <h2>
                Миний сагс
                <span> ({props.basketItems.length} бүтээгдэхүүн)</span>
              </h2>
              <i className="icon icon-cross" onClick={() => closeSidebar()}></i>
            </div>
          )}

          <DeliveryProgress totalAmount={props.totalAmount} />

          <div className="sidebar-content">
            {props.basketItems.map((product: any, pindex: number) => {
              return (
                <div className="basket-item" key={"basket-item-" + pindex}>
                  <div className="product-details">
                    <Link to={"/product/" + product.slug}>
                      <img
                        className="product-image"
                        src={product.imageSmUrl}
                        onClick={() => closeSidebar()}
                      />
                    </Link>
                    <div className="product-right">
                      <div className="product-name">
                        <div className="name">
                          <Link
                            to={"/product/" + product.slug}
                            onClick={() => closeSidebar()}
                          >
                            {product.name}(
                            {product.size && product.unit ? (
                              <span className="price-per">
                                {product.size + " " + product.unit}
                              </span>
                            ) : null}
                            )
                          </Link>
                        </div>
                        <div className="product-amount">
                          <div className="product-count">
                            <LuMinus
                              className="caret"
                              onClick={() => itemDecreaseCount(pindex)}
                            />
                            <input
                              type="number"
                              value={product.count}
                              onChange={(e) => onItemCountChange(pindex, e)}
                              onBlur={(e) => onItemCountBlur(pindex, e)}
                            />
                            <LuPlus
                              className="caret"
                              onClick={() => itemIncreaseCount(pindex)}
                            />
                          </div>

                          <div className="stock-line">
                            {product.warehouseCount <= product.count
                              ? "Боломжит үлдэгдэл: " + product.warehouseCount
                              : ""}
                          </div>
                        </div>
                        <div className="product-price">
                          <NumberFormat
                            displayType={"text"}
                            value={getEffectivePrice(product, props.client?.company?.clubMember)}
                            suffix="₮"
                            thousandSeparator={true}
                          />
                          &nbsp;x <span>{product.count}</span> =
                          <NumberFormat
                            displayType={"text"}
                            value={getEffectivePrice(product, props.client?.company?.clubMember) * product.count}
                            suffix="₮"
                            thousandSeparator={true}
                          />
                        </div>

                        <div className="control"></div>
                      </div>
                      <span
                        className="remove"
                        onClick={() => removeItemFromBasket(product)}
                      >
                        <IoTrashOutline size={mobile ? 25 : 30} />
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="check-out-line">
          <div className="basket-column">
            <div className="basket-row">
              <p>Захиалгын дүн:</p>
              <NumberFormat
                displayType={"text"}
                value={props.totalAmount}
                suffix="₮"
                thousandSeparator={true}
              />
            </div>
            <div className="basket-row">
              <p>Хүргэлтийн үнэ:</p>
              <NumberFormat
                displayType={"text"}
                value={deliveryFee}
                suffix="₮"
                thousandSeparator={true}
              />
            </div>
            <div className="basket-row">
              <h2>Нийт дүн:</h2>
              <h2>
                <NumberFormat
                  displayType={"text"}
                  value={calculatedTotal}
                  suffix="₮"
                  thousandSeparator={true}
                />
              </h2>
            </div>
          </div>

          <Button
            className={
              "continue ui button" +
              (props.totalAmount === 0 ? " disabled" : "")
            }
            onClick={() => continueAction()}
          >
            Үргэлжлүүлэх
          </Button>
        </div>
      </div>

      <Modal
        basic={true}
        dimmer="blurring"
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        open={open}
      >
        {/* <Modal.Header>
          </Modal.Header> */}
        <Modal.Content scrolling={true}>
          {modalAction === "REGISTER" ? (
            <ClientSignUpComponent modalView={true}></ClientSignUpComponent>
          ) : modalAction === "LOGIN" ? (
            <ClientLoginComponent modalView={true}></ClientLoginComponent>
          ) : null}
          {modalAction === "REGISTER" ? (
            <FormGroup>
              <Button
                className="width-100"
                onClick={() => setModalAction("LOGIN")}
              >
                Нэвтрэх
              </Button>
            </FormGroup>
          ) : modalAction === "LOGIN" ? (
            <FormGroup>
              <a
                className="width-100"
                href="/signup"
                style={{ color: "white", marginTop: 20 }}
              >
                Шинэ хэрэглэгч
              </a>
            </FormGroup>
          ) : null}
        </Modal.Content>
      </Modal>
    </div>
  );
}

export default connect(mapStateToProps)(BasketSidebar);
